// src/lib/types/installationScopeTree.ts

export enum ScopeNodeDecision {
  Include = 'INCLUDE',
  Exclude = 'EXCLUDE',
  Passthrough = 'PASSTHROUGH'
}

export interface NodeManifest {
  name: string;
  id: string;
}

export enum ScopeNodeType {
  Country = 'ScopeNodeCountry',
  Chain = 'ScopeNodeChain',
  SubChain = 'ScopeNodeSubChain',
  Region = 'ScopeNodeRegion',
  Location = 'ScopeNodeLocation',
  Installation = 'ScopeNodeInstallation'
}

interface BaseScopeNode<T extends ScopeNodeType, TChild> {
  id: string;
  name: string;
  orphaned: boolean;
  installationCount: number;
  decision: ScopeNodeDecision;
  scopeNodeType: T;
  children: TChild[];
  manifests: NodeManifest[];
}

export type ScopeNodeInstallation = BaseScopeNode<ScopeNodeType.Installation, never>;

export type ScopeNodeLocation = BaseScopeNode<ScopeNodeType.Location, ScopeNodeInstallation>;

export type ScopeNodeRegion = BaseScopeNode<ScopeNodeType.Region, ScopeNodeLocation>;

export type ScopeNodeSubChain = BaseScopeNode<ScopeNodeType.SubChain, ScopeNodeRegion>;

export type ScopeNodeChain = BaseScopeNode<ScopeNodeType.Chain, ScopeNodeSubChain>;

export type ScopeNodeCountry = BaseScopeNode<ScopeNodeType.Country, ScopeNodeChain>;

export type AnyScopeNode =
  | ScopeNodeCountry
  | ScopeNodeChain
  | ScopeNodeSubChain
  | ScopeNodeRegion
  | ScopeNodeLocation
  | ScopeNodeInstallation;

export interface ScopeSearchTreeNode {
  id: string;
  chains?: ScopeSearchTreeNode[];
  subChains?: ScopeSearchTreeNode[];
  regions?: ScopeSearchTreeNode[];
  locations?: ScopeSearchTreeNode[];
  installations?: ScopeSearchTreeNode[];
}
